module.exports = __webpack_public_path__ + "img/icon-plus-white.6993092c.svg";